export const environment = {
        production: true,
        root_negarit_url: 'https://api.negarit.net/api/',
        root_url: 'https://api.turumba.net/'
        // root_url: 'http://172.20.10.3:8080/'
    }
;
